import jqr from "jquery";

// Loads external scripts in sequence
export const loadScripts = (scripts, parent, callback, index = 0) => {
  window.$ = jqr;
  window.jQuery = jqr;
  console.log('loadScript:', scripts[index]);
  const script = document.createElement('script');
  script.src = scripts[index];
  script.onload = (index + 1 < scripts.length) ?
    () => { loadScripts(scripts, parent, callback, ++index); } :
    callback;
  parent.appendChild(script);
};

// CSV to JSON
// https://gist.github.com/atomkirk/eccb66f77b306d0d1fcecb2c605bd22e
function parseCsv(str, opts = {}) {
  var arr = [];
  var quote = false;  // true means we're inside a quoted field
  var col, c;
  // iterate over each character, keep track of current row and column (of the returned array)
  for (var row = col = c = 0; c < str.length; c++) {
    var cc = str[c], nc = str[c+1];
    arr[row] = arr[row] || [];
    arr[row][col] = arr[row][col] || '';
    if (cc === '"' && quote && nc === '"') { arr[row][col] += cc; ++c; continue; }
    if (cc === '"') { quote = !quote; continue; }
    if (cc === ',' && !quote) { ++col; continue; }
    if (cc === '\r' && nc === '\n' && !quote) { ++row; col = 0; ++c; continue; }
    if (cc === '\n' && !quote) { ++row; col = 0; continue; }
    if (cc === '\r' && !quote) { ++row; col = 0; continue; }
    arr[row][col] += cc;
  }
  // Add headers
  if (opts.headers) {
    let header = arr[0];
    let rest = arr.slice(1);
    return rest.map(r => {
      return r.reduce((acc, v, i) => {
        let key = header[i];
        acc[key] = v;
        return acc;
      }, {});
    });
  }
  else {
    return arr;
  }
}

// Load any URL
export const loadURL = (url, format = '') => {
  console.log('loadURL:', url);
  return fetch(url)
    .then(function (response) {
      if(response.ok){
        return response.text();
      }
      throw new Error('Error message.');
    })
    .then(function (data) {
      if (format === 'csv') return parseCsv(data, { headers: true });
      if (format === 'json') return JSON.parse(data);
      return data;
    })
    .catch(function (err) {
      console.log('Failed to loadURL', url, err.message);
    });
};

export const sleep = time => new Promise(resolve => setTimeout(resolve, time));
